import { ButtonProps, Stack, StackProps } from '@mui/material'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'

import { useAuction } from '../Contexts'
import { BidButton } from './BidButton'
import { MintButton } from './MintButton'
import { MintNowButton } from './MintNowButton'
import { MintWithRewardButton } from './MintWithRewardButton'

interface Props extends StackProps {
  quadkey?: Quadkey
  size?: ButtonProps['size']
}

const Actions: React.FC<Props> = ({ size, quadkey, ...props }) => {
  const { auction } = useAuction(quadkey)

  if (auction) {
    return (
      <Stack direction="row" spacing={1} {...props}>
        <BidButton size={size} quadkey={quadkey} />
        <MintButton size={size} quadkey={quadkey} />
        <MintNowButton size={size} quadkey={quadkey} />
        <MintWithRewardButton size={size} quadkey={quadkey} />
      </Stack>
    )
  }
  return null
}

export default Actions
